// extracted by mini-css-extract-plugin
module.exports = {"header":"LessonsHistory_header_160pg"};